import { useLaunchDarklyFactory } from '@sg/launch-darkly';

import { LaunchDarklyProviderContext } from './LaunchDarklyProviderContext';

// ─────────────────────────────────────────────────────────────────────────────

export const useLaunchDarkly = () => {
  return useLaunchDarklyFactory({ Context: LaunchDarklyProviderContext });
};
